import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import "./App.css";
import Navbar from "./components/Layout/Navbar";
import Footer from "./components/Layout/Footer";
import Home from "./pages/Home";
import Download from "./pages/Download";
import Register from "./pages/Register";
import History from "./pages/History";
import Characters from "./pages/Characters";
import World from "./pages/World";
import Comunity from "./pages/Comunity";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/download" element={<Download />} />
                <Route path="/register" element={<Register />} />
                <Route path="/History" element={<History />} />
                <Route path="/Characters" element={<Characters />} />
                <Route path="/World" element={<World />} />
                <Route path="/Comunity" element={<Comunity />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
